import type { IContentState } from '@/store/modules/content/types';

export const state: IContentState = {
  section: null,
  questions: null,
  passages: null,
  assets: null,
};
